export const DOCUMENT_UPLOAD_STANDARD_MAX_SIZE_MB = 50
export const DOCUMENT_UPLOAD_STANDARD_MAX_SIZE_BYTES =
  DOCUMENT_UPLOAD_STANDARD_MAX_SIZE_MB * 1024 * 1024

// Caps multipart field-name nesting (e.g. `a[b][c]` = depth 2) to mitigate the
// unbounded-nesting CPU/memory DoS in multer < 2.2.0 (GHSA-72gw-mp4g-v24j).
// multer defaults this to Infinity, so it must be set explicitly on every
// upload middleware. Upload handlers use flat field names (depth 0); 5 leaves
// headroom for shallow nested/array fields while bounding the attack surface.
export const MULTER_MAX_FIELD_NESTING_DEPTH = 5

export const DOCUMENT_UPLOAD_STREAMING_MAX_SIZE_MB = 100
export const DOCUMENT_UPLOAD_STREAMING_MAX_SIZE_BYTES =
  DOCUMENT_UPLOAD_STREAMING_MAX_SIZE_MB * 1024 * 1024

export const DOCUMENT_UPLOAD_LARGE_FILE_WARNING_SIZE_MB = 50
export const DOCUMENT_UPLOAD_LARGE_FILE_WARNING_SIZE_BYTES =
  DOCUMENT_UPLOAD_LARGE_FILE_WARNING_SIZE_MB * 1024 * 1024

const createDocumentUploadTooLargeMessage = (maxSizeMb: number) =>
  `File is too large. Please upload a file that is ${maxSizeMb}MB or smaller.`

export const DOCUMENT_UPLOAD_STANDARD_TOO_LARGE_MESSAGE =
  createDocumentUploadTooLargeMessage(DOCUMENT_UPLOAD_STANDARD_MAX_SIZE_MB)
export const DOCUMENT_UPLOAD_STREAMING_TOO_LARGE_MESSAGE =
  createDocumentUploadTooLargeMessage(DOCUMENT_UPLOAD_STREAMING_MAX_SIZE_MB)
export const DOCUMENT_UPLOAD_LARGE_FILE_WARNING_MESSAGE = `Large files may take longer to upload and process.`
export const DOCUMENT_UPLOAD_EMPTY_FILE_MESSAGE =
  'File is empty. Please upload a file with content.'

export const getDocumentUploadLimit = (streamingUploadsEnabled: boolean) =>
  streamingUploadsEnabled
    ? {
        maxSizeMb: DOCUMENT_UPLOAD_STREAMING_MAX_SIZE_MB,
        maxSizeBytes: DOCUMENT_UPLOAD_STREAMING_MAX_SIZE_BYTES,
        tooLargeMessage: DOCUMENT_UPLOAD_STREAMING_TOO_LARGE_MESSAGE,
      }
    : {
        maxSizeMb: DOCUMENT_UPLOAD_STANDARD_MAX_SIZE_MB,
        maxSizeBytes: DOCUMENT_UPLOAD_STANDARD_MAX_SIZE_BYTES,
        tooLargeMessage: DOCUMENT_UPLOAD_STANDARD_TOO_LARGE_MESSAGE,
      }
